import Head from "next/head";
import styles from "./refundpolicy.module.css";


export default function RefundPolicyPage() {


  
  return (
    <>

    <Head>
    <title>Return And Refund Policy | School of Our Divine Infinite Being Shop</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Return Policy, Refund Policy, Damaged Items, Defective Products, Buyer's Remorse, Store Policy, Customer Service, School of Our Divine Infinite Being"
    ></meta>
    <meta
      property="og:title"
      content="Our Promise & Policy on Returns and Refunds"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/return_policy_og_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="An overview of the return and refund policy for the School of Our Divine Infinite Being online shop, detailing procedures for damaged or incorrect items."
    ></meta>
    <meta
      property="og:description"
      content="Read our promise and policy on returns and refunds. We offer free replacements or full refunds for any damaged, defective, or incorrect items. Learn more about our process for on-demand products."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/returns-policy"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/return_policy_og_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="An overview of the return and refund policy for the School of Our Divine Infinite Being online shop, detailing procedures for damaged or incorrect items."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/returns-policy"
    ></meta>
    <meta
      name="twitter:title"
      content="Our Promise & Policy on Returns and Refunds"
    ></meta>
    <meta
      name="twitter:description"
      content="Read our promise and policy on returns and refunds. We offer free replacements or full refunds for any damaged, defective, or incorrect items. Learn more about our process for on-demand products."
    ></meta>
       <link rel="canonical" href="https://www.divineinfinitebeing.com/returns-policy" />
</Head>
    <div className={styles.refund_full_width}>
      <div className={styles.refund_box_wrpr}>
        <div className={styles.refund_text_box}>
          <div className={styles.refund_text_box_inner}>
            {/* <div className={styles.border_box}></div> */}
            

            <div class={styles.border_box}><h2 className={styles.border_box_text}>Our Promise &amp; Policy</h2></div>
            <p>
              Your happiness is our priority. Every item we sell is created
              on-demand, just for you, which means we have a unique approach to
              returns. Please read this policy carefully to understand the
              process.
            </p>

            <h3>For Damaged, Defective, or Incorrect Items</h3>
            <p>
              If your order arrives with a quality issue—such as a misprint, a
              defect in the product, or damage from shipping—we will make it
              right.
            </p>
            <ul>
              <li>
                <strong>Timeframe:</strong> You must report the issue within{" "}
                <strong>30 days</strong> of delivery.
              </li>
              <li>
                <strong>What We Need From You:</strong> Email our support team
                at{" "}
                <a href="mailto:support@divineinfinitebeing.com">
                  support@divineinfinitebeing.com
                </a>{" "}
                with:
                <ul>
                  <li>Your order number</li>
                  <li>A clear photo or video showing the issue</li>
                  <li>A brief description of the problem</li>
                </ul>
              </li>
              <li>
                <strong>Our Solution:</strong> Once we verify the issue, you may
                choose a <strong>free replacement</strong> or a{" "}
                <strong>full refund</strong>.
              </li>
              <li>
                <strong>No Need to Return:</strong> You do not need to send the
                faulty item back to us. You can keep it, donate it, or dispose
                of it.
              </li>
            </ul>

            <h3>For Other Issues (Buyer’s Remorse)</h3>
            <p>
              Because each product is made to order, we cannot accept returns or
              offer refunds if:
            </p>
            <ul>
              <li>You ordered the wrong size, color, or product</li>
              <li>You’ve simply changed your mind</li>
              <li>The item was damaged through customer misuse</li>
            </ul>
            <p>
              To help you order correctly, we provide detailed sizing charts and
              product descriptions on every product page. Please review these
              carefully before completing your purchase.
            </p>
            <p>
              If you have any questions before you order, please contact our
              support team—we’re here to help!
            </p>

            <h3>How to Contact Us</h3>
            <p>
              Email:{" "}
              <a href="mailto:support@divineinfinitebeing.com">
                support@divineinfinitebeing.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    </>
  );
}
